export const FETCH_UNITS_SETTINGS_REQUEST =
  'unitsSettings/FETCH_UNITS_SETTINGS_REQUEST'
export const FETCH_UNITS_SETTINGS_SUCCESS =
  'unitsSettings/FETCH_UNITS_SETTINGS_SUCCESS'
export const FETCH_UNITS_SETTINGS_FAILURE =
  'unitsSettings/FETCH_UNITS_SETTINGS_FAILURE'

export const UPDATE_UNITS_SETTINGS_REQUEST =
  'unitsSettings/UPDATE_UNITS_SETTINGS_REQUEST'
export const UPDATE_UNITS_SETTINGS_SUCCESS =
  'unitsSettings/UPDATE_UNITS_SETTINGS_SUCCESS'
export const UPDATE_UNITS_SETTINGS_FAILURE =
  'unitsSettings/UPDATE_UNITS_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'unitsSettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'unitsSettings/SET_DEFAULT_DATA'
